/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiNote } from './ApiNote';
import {
    ApiNoteFromJSON,
    ApiNoteFromJSONTyped,
    ApiNoteToJSON,
    ApiNoteToJSONTyped,
} from './ApiNote';

/**
 * 
 * @export
 * @interface ApiBulkStatus
 */
export interface ApiBulkStatus {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiBulkStatus
     */
    ids: Array<number>;
    /**
     * 
     * @type {ApiNote}
     * @memberof ApiBulkStatus
     */
    note: ApiNote;
    /**
     * 
     * @type {string}
     * @memberof ApiBulkStatus
     */
    status: string;
}

/**
 * Check if a given object implements the ApiBulkStatus interface.
 */
export function instanceOfApiBulkStatus(value: object): value is ApiBulkStatus {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ApiBulkStatusFromJSON(json: any): ApiBulkStatus {
    return ApiBulkStatusFromJSONTyped(json, false);
}

export function ApiBulkStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiBulkStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'note': ApiNoteFromJSON(json['note']),
        'status': json['status'],
    };
}

export function ApiBulkStatusToJSON(json: any): ApiBulkStatus {
    return ApiBulkStatusToJSONTyped(json, false);
}

export function ApiBulkStatusToJSONTyped(value?: ApiBulkStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'note': ApiNoteToJSON(value['note']),
        'status': value['status'],
    };
}

